import * as React from "react";
import { AssemblyApiContext } from "../types/assembly-context";

/**
 * Holds the active Assembly's source + identifiers so deeply nested
 * components (the reference builder, condition editor, template editors)
 * can address the correct backend without prop-drilling.
 */
const AssemblyContext = React.createContext<AssemblyApiContext | null>(null);

export const AssemblyProvider = AssemblyContext.Provider;

export const useAssemblyContext = (): AssemblyApiContext => {
  const ctx = React.useContext(AssemblyContext);
  if (!ctx) {
    throw new Error("useAssemblyContext must be used within an AssemblyProvider");
  }
  return ctx;
};
